import React, { FC } from 'react';
import { VehicleDetailsHeadingInformationProps } from '.';
import TitleWithBenefits from '@components/v2/TitleWithBenefits';
import { formatLeadTime } from '@utils/Date.utils';
import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';

const VehicleDetailsHeadingInformationTemplate: FC<VehicleDetailsHeadingInformationProps> = ({ className, onClick }) => {
    const { carDetails } = useCarDetailsDuck();

    return (
        <div className={className}>
            <div className="information">
                <TitleWithBenefits withBenefits={false} isSpeckPackTitleBold={false} onClick={onClick} />
            </div>
            <span className="delivery">{formatLeadTime(carDetails.leadTimeDate)}</span>
        </div>
    );
};
export default VehicleDetailsHeadingInformationTemplate;
